import type { VacationRequestsRepositoryT } from "../../domain/ports/vacationRequests.repository";
import type { UpdateVacationRequestsDataT } from "../../domain/types/updateVacationRequests.types";

type UpdateVacationRequestParamsT = {
  vacationRequestsRepository: VacationRequestsRepositoryT;
  data: UpdateVacationRequestsDataT[];
  colaboraInstanceId: string;
};

export const updateVacationRequest = async ({
  vacationRequestsRepository,
  data,
  colaboraInstanceId,
}: UpdateVacationRequestParamsT) => {
  return await vacationRequestsRepository.updateVacationRequest(
    data,
    colaboraInstanceId,
  );
};
